export function OneOneSvg({ fillColor = "#FFFFFF", size = 50 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_45257_22210)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.44043 4.15918C7.56115 4.15924 9.28027 5.87829 9.28027 7.99902C9.28021 10.1197 7.56111 11.8388 5.44043 11.8389C3.3197 11.8389 1.60065 10.1197 1.60059 7.99902C1.60059 5.87825 3.31966 4.15918 5.44043 4.15918ZM5.17676 13.1123L5.44043 13.1191C6.37329 13.1191 7.24788 12.8696 8.00113 12.4337L7.18594 11.8473C8.64856 11.1833 9.66575 9.70997 9.66575 7.99907C9.66575 6.2889 8.64943 4.8161 7.18782 4.15171L8.00954 3.56934C7.3257 3.17189 6.54143 2.92824 5.7041 2.88574L5.44043 2.87891C2.61273 2.87891 0.320312 5.17133 0.320312 7.99902L0.327148 8.2627C0.46001 10.8805 2.55891 12.9796 5.17676 13.1123Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.18481 4.15005C6.11604 5.08843 5.44141 6.46488 5.44141 7.99891C5.44141 9.53293 6.11604 10.9094 7.18481 11.8478C8.64818 11.1841 9.66603 9.71036 9.66603 7.99891C9.66603 6.28745 8.64818 4.81373 7.18481 4.15005ZM8.00172 12.4341C8.75473 12.8696 9.62896 13.1189 10.5614 13.1189C13.3891 13.1189 15.6814 10.8266 15.6814 7.99891C15.6814 5.17121 13.3891 2.87891 10.5614 2.87891C9.62896 2.87891 8.75473 3.12817 8.00172 3.56369C9.53226 4.44892 10.562 6.10365 10.562 7.99891C10.562 9.89416 9.53226 11.5489 8.00172 12.4341Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_45257_22210">
          <rect
            width="15.36"
            height="15.36"
            fill="white"
            transform="translate(0.320312 0.320312)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
